export const deliveryMailReceiveSetting = "https://www.ra9plus.jp/guide/delivery_mail_receive_setting/"
